export function buildTerminalStateQueryKey(children?: (string | number)[]) {
	return ['terminal-state', ...(children ?? [])];
}
